<template>
  <app-view @open="onOpen" @restore="onRestore" @close="onClose">
    <list ref="list" :loadNextPage="loadNextPage" :clear="clear">
      <router-link class="item" v-for="(item,index) in list" :key="index"
                   :to="{name:'news-detail',params:{id:item.id}}">
        <span>{{index + 1}}. {{item.title}}</span>
        <span>{{item.addtime | date}}<i class="icon icon-right"></i></span>
      </router-link>
    </list>
    <div class="tab fixedTop">
      <a href="javascript:;" v-for="(item,index) in types"
         :class="{on:type===index}"
         @click="onSwitch(index)">{{item}}</a>
    </div>
  </app-view>
</template>
<script>
  import AppView from '../components/AppView.vue'
  import List from '../components/List.vue'

  export default {
    components: {AppView, List},
    data () {
      return {
        types: ['站内公告', '最新动态']
      }
    },
    computed: {
      type () {
        return this.$service.news.type
      },
      list () {
        return this.$service.news.list
      }
    },
    methods: {
      onSwitch (type) {
        this.$service.news.type = type
        this.$service.common.title = this.types[type]
        this.$refs.list.reload()
      },
      clear () {
        this.$service.news.clear()
      },
      loadNextPage () {
        this.$service.news.loadNext()
      },
      onOpen () {
        this.onSwitch(0)
      },
      onRestore () {
        if (this.list.length === 0) {
          this.onOpen()
        } else {
          this.$service.common.title = this.types[this.type]
        }
      },
      onClose () {
        this.$service.news.clear()
      }
    }
  }
</script>
<style scoped lang='scss'>
  .view {
    padding-top: 44px;
    .tab {
      display: flex;
      line-height: 44px;
      border-bottom: thin solid $color-red;
      background-color: $color-white;
      a {
        flex: 1;
        text-align: center;
        &.on {
          border-bottom: 2px solid $color-red;
        }
      }
    }
    .item {
      display: flex;
      align-items: center;
      background-color: $color-white;
      line-height: 44px;
      border-bottom: $style-border;
      padding: 0 $app-padding;
      &:active {
        background-color: rgba(0, 0, 0, 0.1);
      }
      > span {
        &:first-child {
          flex: 1;
          color: $primary-text-color;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &:last-child {
          color: $thirdly-text-color;
        }
      }
      i {
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?47e3dd54